import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import StockFull from './stock-full';

const StockFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <StockFull {...props}/>
    </QueryClientProvider>
  );
};

export { StockFullWidget }
